export default "__VITE_ASSET__BEoBXo9N__"